module.exports = __webpack_public_path__ + "img/09fcdfe.jpg";